/* eslint-disable @typescript-eslint/restrict-template-expressions */
import React, { useEffect } from 'react'
import BasicTabs from './DeviceTable/DeviceListAmi'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import ListIcon from '@mui/icons-material/List'
import MapIcon from '@mui/icons-material/Map'
import { type RootState } from '../../../store'
import { type ConnectedProps, connect, useSelector } from 'react-redux'
import { Grid } from '@mui/material'
import { getTopIssuesGeoJson } from '../../Maps/redux/actionCreator'
import { type TopIssuesGeoJsonState } from '../../Maps/types'
import GeoJsonMap from '../../Maps/GeoJsonMap'
import LanguageStrings from '../../../i18n/locales'
import { type KeysFromKeyVaultState } from '../../dashboard/redux/keysFromKeyVaultSlice'
import { fetchKeyFromKeyVault } from '../../dashboard/redux/actionCreator'

const AlarmStrings = LanguageStrings().AMIDataCollectionStrings.AlarmComponet

const Alarm = (props: AllProps): JSX.Element => {
  const totalIssueCount = useSelector(
    (state: RootState) => state.totalIssuesCount
  )

  const [alignment, setAlignment] = props.alignmentObj

  useEffect(() => {
    props.getTopIssuesGeoJson(true, 20000)
    if (props.keyVaultState.keys.GOOGLE_MAPS_API_KEY === '') {
      props.fetchKeyFromKeyVault('GOOGLE-API-KEY', 'GOOGLE_MAPS_API_KEY')
    }
  }, [])

  const handleAlignment = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null
  ): any => {
    // istanbul ignore next
    if (newAlignment !== alignment) {
      setAlignment(newAlignment)
    }
  }

  const toggleviews = (): any => {
    // istanbul ignore else
    if (alignment === 'list') {
      return (
        <BasicTabs />
      )
    } else {
      return (
        <div style={ { height: '100%', padding: '10px' } }>
          <div id='MapCardAmi' style={{ height: `calc(${props.height}px - 35px)` }}>
            <GeoJsonMap GOOGLE_MAPS_API_KEY={props.keyVaultState.keys.GOOGLE_MAPS_API_KEY} />
          </div>
        </div>
      )
    }
  }
  return (
    <Grid
      container
      sx={{
        borderRadius: '10px',
        backgroundColor: '#272727',
        color: '#f0f0f0'
      }}
    >
      <div className="top-issues-header">
        <div style={{ fontSize: '18px' }}>
          {AlarmStrings.TopIssuesList} ({totalIssueCount})
        </div>
        <div style={{ backgroundColor: '#505050', borderRadius: '4px' }}>
          <ToggleButtonGroup
            color="primary"
            value={alignment}
            exclusive
            onChange={handleAlignment}
            aria-label="text alignment"
            sx={{
              padding: '2px',
              backgroundColor: '#505050',
              border: 'none'
            }}
          >
            <ToggleButton
              sx={{ border: 'none', borderRadius: '4px' }}
              value="list"
              aria-label="left aligned"
              data-testid="left aligned"
              disabled={alignment === 'list'}
            >
              <ListIcon />
            </ToggleButton>
            <ToggleButton
              sx={{ border: 'none', borderRadius: '4px' }}
              value="map"
              aria-label="right aligned"
              data-testid="right aligned"
              disabled={alignment === 'map'}
            >
              <MapIcon />
            </ToggleButton>
          </ToggleButtonGroup>
        </div>
      </div>
      <div style={{ width: '100%' }}>{toggleviews()}</div>
    </Grid>
  )
}

interface DispatchToProps {
  getTopIssuesGeoJson: (unPaged: boolean, limit: number) => void
  fetchKeyFromKeyVault: (keyVaultKey: string, keyName: string) => void
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
  getTopIssuesGeoJson: (unPaged: boolean, limit: number) => dispatch(getTopIssuesGeoJson(unPaged, limit)),
  fetchKeyFromKeyVault: (keyVaultKey: string, keyName: string) => dispatch(fetchKeyFromKeyVault(keyVaultKey, keyName))
})

interface StateToProps {
  topIssuesGeoJson: TopIssuesGeoJsonState
  keyVaultState: KeysFromKeyVaultState
}

const mapStateToProps = (state: RootState): StateToProps => ({
  topIssuesGeoJson: state.topIssuesGeoJson,
  keyVaultState: state.keyVaultState
})

const connector = connect(mapStateToProps, mapDispatchToProps)

interface ParentProps {
  height: number
  alignmentObj: any
}

type PropsFromRedux = ConnectedProps<typeof connector>
type AllProps = ParentProps & PropsFromRedux

export default connector(Alarm)
